import {
  AccountIdentity,
  accountIdentity,
  AnyAccountId,
  anyAccountId,
  RoomContextId,
  roomContextId,
  RoomId,
  roomId,
  StreamId,
  streamId,
  StreamIsActive,
  streamIsActive,
  StreamKind,
  streamKinds
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamToPublishCreateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamToPublishCreateRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamToPublishCreateRequestDTORaw) {
    JsonSchemaValidator.assert(
      RoomStreamToPublishCreateRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: [
        "accountId",
        "accountIdentity",
        "roomId",
        "roomContextId",
        "streamId",
        "streamIsActive",
        "streamKinds"
      ],
      properties: {
        accountId: anyAccountId,
        accountIdentity,
        roomId,
        roomContextId,
        streamId,
        streamIsActive,
        streamKinds
      },
      additionalProperties: false
    };
  }
}

export interface RoomStreamToPublishCreateRequestDTORaw {
  accountId: AnyAccountId;
  accountIdentity: AccountIdentity;
  roomId: RoomId;
  roomContextId: RoomContextId;
  streamId: StreamId;
  streamIsActive: StreamIsActive;
  streamKinds: StreamKind[];
}
